__webpack_require__.p = "https://livret.simplon-ara.fr/";